import styled from "styled-components";

const ComponentTimeGrid = styled.div`
  .Row-title-dataTime {
    justify-content: space-between;

    .Row-header-dataTime {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 6px;

      p {
        font-family: "Roboto", sans-serif;
        font-weight: 500;
        margin-bottom: 0px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .Col-content-dataTime {
      display: flex;
      flex-direction: column;
    }

    .Col-rateTable-dataTime {
      /* background-color: #f3f6f9; */
      display: flex;
      flex-direction: column;
      gap: 8px;
      margin: 12px 4px 0px;
      border-radius: 8px;
      flex-grow: 1;
      padding: 0px 0px 2px;
      height: 256px;
    }

    .Col-rateTable-dataTime-availability {
      background-color: #f4f6f7;
      height: 262px;
      cursor: no-drop;
      box-shadow: 0px 2px 1px #e0e3e5;
    }

    .text-rateTable-dataTime {
      margin: auto;
      text-align: center;
      text-wrap: wrap;
      text-overflow: hidden;
      padding: 0px 8px;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-word;
      color: #9daab8;
    }
  }

  .Row-Content--dataTime {
    padding: 11px 38px 20px;
  }

  .Row-Content--classTime {
    padding: 30px 42px 20px;
  }

  .class-schedule-skeleton {
    width: 100%;
    height: 68px;
    border-radius: 12px;
  }

  .class-schedule-grid {
    display: grid;
    gap: 8px 12px;
    width: 100%;
    align-content: start;
  }

  @media (min-width: 992px) {
    .class-schedule-grid {
      min-height: 298px;
    }
  }

  .class-schedule-grid.single-slot {
    grid-template-columns: 1fr;
  }

  .class-schedule-grid.multi-slot {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .class-schedule-grid.triple-slot {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .class-schedule-grid.triple-slot .class-schedule-card {
    padding: 10px 8px;
    gap: 4px;
  }

  .class-schedule-grid.triple-slot .class-schedule-time {
    font-size: 14px;
  }

  .class-schedule-grid.triple-slot .class-schedule-period {
    font-size: 11px;
  }

  .class-schedule-card {
    min-height: 68px;
    border: 1px solid transparent;
    border-radius: 12px;
    background: #ffffff;
    box-shadow: none;
    cursor: pointer;
    display: grid;
    grid-template-columns: 36px minmax(0, 1fr) auto;
    align-items: center;
    gap: 8px;
    padding: 4px 8px;
    text-align: left;
    transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
  }

  .class-schedule-card:hover:not(:disabled) {
    box-shadow: 0px 10px 30px rgba(2, 6, 9, 0.08);
    transform: translateY(-1px);
  }

  .class-schedule-selected {
    border-color: #00e676;
    box-shadow: 0px 8px 24px rgba(0, 230, 118, 0.18);
  }

  .class-schedule-disabled {
    cursor: not-allowed;
    opacity: 0.45;
  }

  .class-schedule-icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .class-schedule-icon svg {
    width: 24px;
    height: 24px;
  }

  .class-schedule-info {
    display: grid;
    min-width: 0;
  }

  .class-schedule-time {
    font-family: "Roboto", sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 18px;
    white-space: nowrap;
  }

  .class-schedule-period {
    font-family: "Roboto", sans-serif;
    font-size: 13px;
    font-weight: 400;
    line-height: 16px;
    color: #555555;
    white-space: nowrap;
  }

  .class-schedule-period-name,
  .class-schedule-duration-inline {
    color: inherit;
  }

  .class-schedule-duration {
    display: none;
    font-family: "Roboto", sans-serif;
    font-size: 13px;
    color: #555555;
    white-space: nowrap;
  }

  .class-schedule-card.hour-early-morning {
    color: #c382d9;
  }

  .class-schedule-card.hour-morning {
    color: #ff9e44;
  }

  .class-schedule-card.hour-afternoon {
    color: #ff7425;
  }

  .class-schedule-card.hour-night {
    color: #8a2be2;
  }

  @media (min-width: 992px) {
    .class-schedule-grid.single-slot .class-schedule-card {
      grid-template-columns: 36px minmax(0, 1fr);
    }
  }

  @media (max-width: 992px) {
    .class-schedule-grid.multi-slot {
      grid-template-columns: 1fr;
    }

    .class-schedule-grid.triple-slot {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .class-schedule-grid.triple-slot .class-schedule-card {
      padding: 10px 16px;
      gap: 8px;
    }

    .class-schedule-grid.triple-slot .class-schedule-time {
      font-size: 16px;
    }

    .class-schedule-grid.triple-slot .class-schedule-period {
      font-size: 13px;
    }

    .class-schedule-card {
      grid-template-columns: 36px minmax(0, 1fr) auto;
    }

    .class-schedule-duration {
      display: block;
    }

    .class-schedule-duration-inline {
      display: none;
    }
  }

  @media (max-width: 768px) {
    .class-schedule-grid.triple-slot {
      grid-template-columns: 1fr;
    }
  }

  .Row-grid {
    justify-content: space-between;
  }

  .hour-slot {
    width: 157px;
    /* height: 38px; */
    border-radius: 10px;
    /* border: 1px solid #a5abb0; */
    /* background-color: #fbfbfb; */
    color: #a5abb0;
    justify-content: center;
    align-items: center;
    display: flex;
    background-color: #fbfbfb;
    box-shadow: 0px 2px 1px #e0e3e5;
    cursor: pointer;
    font-size: 12px;
    height: 100%;
  }

  .hour-slot-big {
    /* height: 52px; */
  }

  .hour-slot > button {
    font-weight: bold;
    border: 0px;
    margin: 0px;
    padding: 0px;
    height: 100%;
    border-radius: 10px;
    .hour-slot-text-dash {
      padding: 0px 2px;
      display: inline-block;
    }
  }

  .hour-available {
    box-shadow: 0px 2px 1px #e0e3e5;
  }

  .hour-morning {
    color: #ff9e44;
  }

  .hour-morning > button {
    color: #ff9e44;
  }

  .hour-afternoon {
    color: #ff7425;
  }

  .hour-afternoon > button {
    color: #ff7425;
  }

  .hour-night {
    color: #8a2be2;
  }

  .hour-night > button {
    color: #8a2be2;
  }

  .hour-early-morning {
    color: #c382d9;
  }

  .hour-early-morning > button {
    color: #c382d9;
  }

  .hour-selected {
    background: #00e676;
    box-shadow: 0px 4.50725px 13.5217px rgba(0, 230, 118, 0.5);
    border: 1px solid #00e676;
    color: #ffffff;
  }

  .hour-selected > button {
    color: #ffffff;
  }

  .hour-disabled {
    color: #a5abb0;
    border: 1px solid #a5abb0;
    background-color: transparent;
  }

  .hour-disabled > button {
    color: #a5abb0;
    background-color: transparent;
  }

  @media (max-width: 1280px) {
    .text-rateTable-dataTime {
      font-size: 12px;
    }

    .hour-slot > button {
      font-size: 12px;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: word-all;
    }
    .hour-slot > button {
      font-size: 12px;
    }
    .hour-slot > button > span {
      display: inline-block;
    }
  }
  @media (max-width: 480px) {
    .Row-Content--classTime {
      padding: 18px 20px 20px;
    }

    .class-schedule-grid.multi-slot {
      grid-template-columns: 1fr;
    }

    .class-schedule-card {
      min-height: 60px;
      padding: 8px 12px;
      grid-template-columns: 32px minmax(0, 1fr) auto;
      gap: 6px;
    }

    .class-schedule-icon svg {
      width: 22px;
      height: 22px;
    }

    .class-schedule-time {
      font-size: 15px;
      line-height: 17px;
    }

    .class-schedule-period,
    .class-schedule-duration {
      font-size: 12px;
    }

    .Row-header-dataTime {
      flex-direction: column;
      gap: 4px;
      p {
        font-size: 12px;
      }
    }

    .text-rateTable-dataTime {
      font-size: 12px;
    }

    .hour-slot > button {
      padding: 0px 2px;
      font-size: 11px;
      overflow: hidden;
    }
  }

  @media (max-width: 400px) {
    .Row-Content--dataTime {
      padding: 11px 2% 20px;
    }

    .Row-header-dataTime {
      flex-direction: column;
      gap: 4px;
      p {
        font-size: 12px;
      }
    }

    .hour-slot > button {
      padding: 0px 1px;
      font-size: 10px;
      overflow: hidden;
    }
  }

  .class-schedule-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 32px 24px;
    background: #ffffff;
    border-radius: 16px;
    border: 1px dashed #d9e2ec;
    animation: fadeIn 0.4s ease-out;
  }

  @media (min-width: 992px) {
    .class-schedule-empty {
      min-height: 298px;
    }
  }

  .empty-icon-wrapper {
    background: #f0f4f8;
    border-radius: 50%;
    width: 64px;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
    color: #627d98;

    svg {
      width: 32px;
      height: 32px;
    }
  }

  .empty-title {
    font-family: "Roboto", sans-serif;
    font-size: 16px;
    font-weight: 700;
    color: #1b1464;
    margin-bottom: 8px;
  }

  .empty-description {
    font-family: "Roboto", sans-serif;
    font-size: 13px;
    font-weight: 400;
    color: #627d98;
    max-width: 260px;
    line-height: 18px;
    margin: 0;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(8px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;
export default ComponentTimeGrid;
